import { css } from '@emotion/css';

const mobilePlayerViewStyles = css`
  margin-bottom: 10%;
  padding-inline-start: 2rem;
  padding-inline-end: 2rem;
`;

const playerMobileStyle = css`
  max-height: 550px;
`;

export const MOBILE_CLASSES = {
  player: playerMobileStyle,
  preview: mobilePlayerViewStyles,
  question: mobilePlayerViewStyles,
  emptyState: mobilePlayerViewStyles,
};

export const quizCardStyles = css`
  width: 61.6rem !important;
`;

export const quizCardMobileStyles = css`
  width: 100%;
`;

export const mobileDialogPaperStyles = css`
  /* dvh instead of % (of a position: fixed ancestor) so this tracks iOS Safari's
     actual visible viewport instead of the layout viewport behind its toolbar. */
  height: calc(100dvh - 56px);
`;
